module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 26);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("js-cookie");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("smarket-pithy/lib/config");

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1__);


js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.defaults.domain = smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookies.domain') || "";

var getGlobalUserId = function getGlobalUserId() {
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
  uuid = uuid.replace(/-/g, '');
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.globalUserId(uuid, {
    expires: 365
  });
  return uuid;
}; //smarketMember 该cookie表示登陆信息


js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.smarketMember = function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var schemaId = args[0],
      smarketMember = args[1],
      _args$ = args[2],
      options = _args$ === void 0 ? {} : _args$;
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.member') || 'smarketMember', "_").concat(schemaId);

  if (args.length > 1) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(flag, smarketMember, options);
    return;
  }

  return js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.getJSON(flag);
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.smarketMember.remove = function (schemaId) {
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.member') || 'smarketMember', "_").concat(schemaId);
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(flag, {
    path: '/'
  });
}; //操作openId的cookie,该cookie表示用户的微信openId信息


js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.openId = function () {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var weChatId = args[0],
      openId = args[1],
      options = args[2];
  var flag = (smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.openId') || 'openId') + weChatId;

  if (args.length > 1) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(flag, openId, options);
    return;
  }

  return js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.get(flag);
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.openId.remove = function (weChatId) {
  var flag = (smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.openId') || 'openId') + weChatId;
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(flag, {
    path: '/'
  });
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.globalUserId = function () {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  var globalUserId = args[0],
      options = args[1];
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.globalUserId') || 'globalUserId');

  if (args.length > 0) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(flag, globalUserId, options);
    return;
  }

  return js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.get(flag) || getGlobalUserId();
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.globalUserId.remove = function () {
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.globalUserId') || 'globalUserId');
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(flag, {
    path: '/'
  });
}; //操作手机号的cookie,该cookie表示用户手机验证状态


js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.mobile = function () {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  var schemaId = args[0],
      mobile = args[1],
      options = args[2];
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.mobile') || 'mobile', "_").concat(schemaId);

  if (args.length > 1) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(flag, mobile, options);
    return;
  }

  return js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.get(flag);
}; //删除手机号


js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.mobile.remove = function (schemaId) {
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.mobile') || 'mobile', "_").concat(schemaId);
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(flag, {
    path: '/'
  });
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.token = function () {
  for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    args[_key5] = arguments[_key5];
  }

  var schemaId = args[0],
      token = args[1],
      options = args[2];
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.token') || 'token', "_").concat(schemaId);

  if (args.length > 1) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(flag, token, options);
    return;
  }

  return js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.get(flag);
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.token.remove = function (schemaId) {
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.token') || 'token', "_").concat(schemaId);
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(flag, {
    path: '/'
  });
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.tokenInfo = function () {
  for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
    args[_key6] = arguments[_key6];
  }

  var schemaId = args[0],
      tokenInfo = args[1],
      options = args[2];
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.tokenInfo') || 'tokenInfo', "_").concat(schemaId);

  if (args.length > 1) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(flag, tokenInfo, options);
    return;
  }

  return js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.get(flag);
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.tokenInfo.remove = function (schemaId) {
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.tokenInfo') || 'tokenInfo', "_").concat(schemaId);
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(flag, {
    path: '/'
  });
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.verify = function () {
  for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
    args[_key7] = arguments[_key7];
  }

  var weChatId = args[0],
      verify = args[1],
      options = args[2];
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.verify') || 'verify', "_").concat(weChatId);

  if (args.length > 1) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(flag, verify, options);
    return;
  }

  return js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.get(flag);
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.verify.remove = function (weChatId) {
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.verify') || 'verify', "_").concat(weChatId);
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(flag, {
    path: '/'
  });
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.verifyInfo = function () {
  for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
    args[_key8] = arguments[_key8];
  }

  var weChatId = args[0],
      verifyInfo = args[1],
      options = args[2];
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.verifyInfo') || 'verifyInfo', "_").concat(weChatId);

  if (args.length > 1) {
    js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.set(flag, verifyInfo, options);
    return;
  }

  return js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.getJSON(flag);
};

js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.verifyInfo.remove = function (weChatId) {
  var flag = "".concat(smarket_pithy_src_tools_config__WEBPACK_IMPORTED_MODULE_1___default()('cookie.flag.verifyInfo') || 'verifyInfo', "_").concat(weChatId);
  js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a.remove(flag, {
    path: '/'
  });
};

/* harmony default export */ __webpack_exports__["default"] = (js_cookie__WEBPACK_IMPORTED_MODULE_0___default.a);

/***/ })

/******/ });